const { h, render, Component } = require('preact');
const ArticleView = require('../../views/search/article');
const Helper = require('../../../helper')

class Article extends Component {
  constructor(props) {
    super(props);
    this.hideArticle = this.hideArticle.bind(this);
    this.showArticle = this.showArticle.bind(this);
  }

  hideArticle(){
    this.props.hideArticleById(this.props.article.contentId);
  }

  showArticle() {
    Helper.createClickEventInbenta(this.props.article.clickCode)
    this.props.showArticleById(this.props.article.contentId);
  }

  render() {
    if (this.props.article && this.props.article.contentId && this.props.article.title && this.props.article.answer){
      return (
        <ArticleView
          article={this.props.article}
          hideArticle={this.hideArticle}
          showArticle={this.showArticle}
          handleNeedHelpFromSearchResults={this.props.handleNeedHelpFromSearchResults}
          onGuestHelp={this.props.onGuestHelp}
          showGuestHelp={this.props.showGuestHelp}
        />
      );
    }
    return null;
  }
}
module.exports = Article
